import React from "react";
import { SUCCESS_ICON } from "../../../constants/svgs/SVGS";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

const Success = ({ modal_id, title, message, buttonLabel, customerType }) => {
  const navigate = useNavigate();

  const { newCustomer_id } = useSelector(state => state.customer)

  const handleNavigate = () => {
    navigate(`/admin/customer-profile/${newCustomer_id}`)
  };

  return (
    <div
      className='modal fade'
      id={modal_id}
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='staticBackdropLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content rounded-4'>
          <div className='modal-body'>
            <div className='container p-4'>
              <div className='d-flex justify-content-center mb-2'>
                <SUCCESS_ICON />
                {/* <img className='card-icon' src={SUCCESS_ICON} alt="" /> */}
              </div>
              <h3 className='text-dark text-center lh-lg'>Successful!</h3>
              <p className='w-9 mx-auto text-dark fs-5 text-center'>
                Would you like to attach a policy to this customer?
              </p>
              <div className='mt-5'>
                <div className='d-flex justify-content-between'>
                  <span
                    className=' text-dark p-1 px-4 rounded-2 cursor-p'
                    style={{ background: "#e0e0e0" }}
                    data-bs-dismiss='modal'
                    onClick={handleNavigate}
                    
                  >
                    No
                  </span>
                  <span className='bg-primary-1 text-white p-1 px-3 rounded-2 cursor-p'>
                    Attach Policy
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Success;
